import { deviceEvents, EVENTS } from "./events";

/**
 *
 *
 *
 *
 *
 *
 */
export function isTouchable(): boolean {
  const data: [ontouchstart: boolean, documentTouch: boolean, maxTouchPoints: boolean] = [
    "ontouchstart" in window,
    /*                                    */
    !!(window.DocumentTouch && document instanceof window.DocumentTouch),

    !!window.navigator.maxTouchPoints,
  ];

  const isTouchableFlag = data.some(Boolean);
  const { classList } = document.documentElement;

  if (isTouchableFlag) {
    /*                                                                        */
    classList.add("touchable");

    /*                   */
    deviceEvents.emitRetain(EVENTS[1], {
      documentTouch: data[1],
      maxTouchPoints: data[2],
      ontouchstart: data[0],
    });
  } else {
    classList.add("not-touchable");
  }

  return isTouchableFlag;
}
